export default "__VITE_ASSET__Dmk43knI__"